import * as React from 'react'

import { TabsMenu } from '@factorialco/deprecated-design-system'

import type { Tab as TabStruct, TabsType } from 'modules/core/components/Card/types'
import i18n from 'modules/core/lib/i18n'

interface Props {
  noUnderLine?: boolean
  tabs: TabStruct[]
  type?: TabsType
}

const CardTabsMenu = ({ tabs, type, noUnderLine }: Props) => {
  const missingInfoLabel = i18n.t('common.information_missing')
  const moreLabel = i18n.t('common.more')

  return (
    <TabsMenu
      tabs={tabs}
      type={type}
      missingInfoLabel={missingInfoLabel}
      moreLabel={moreLabel}
      noUnderLine={noUnderLine}
    />
  )
}

export default CardTabsMenu
